export enum FieldType {
    NATIVE = 'NATIVE',
    CUSTOM = 'CUSTOM',
    COMPOSITE = 'COMPOSITE',
    SEPARATOR = 'SEPARATOR',
    OPTIONAL = 'OPTIONAL'
}
